/*!
 * @grapecity/activereports 3.0.0
 * Description: ActiveReportsJS
 * https://www.npmjs.com/package/@grapecity/activereports
 * Copyright (c) 2022 GrapeCity, Inc.
 * Licensed under the Commercial license
 */
/*!
 * @grapecity/activereports-designer v3.0.0
 * Author: GrapeCity, Inc.
 * Description: ActiveReportsJS Designer
 */
export{cX as Designer}from"./index-6cb566bb.js";import"../ar-js-pagereport";import"../../gc-dv";import"../../barcodejs";
